<template>
  <div class="custom-icon" :class="{'big':type==='big', 'small':type==='small', 'disabled':disabled}" @click="handleClick" v-if="name.startsWith('el-icon')">
    <el-tooltip :content="content" placement="bottom" effect="light" v-if="content" :open-delay="500" :enterable="false">
      <i :class="name"></i>
    </el-tooltip>
    <i :class="name" v-else></i>
  </div>
  <div class="custom-icon" :class="{'big':type==='big', 'small':type==='small', 'disabled':disabled}" @click="handleClick" v-else>
    <el-tooltip :content="content" placement="bottom" effect="light" v-if="content" :open-delay="500" :enterable="false">
      <svg width="1em" height="1em" :fill="color?'':'currentColor'" aria-hidden="true">
        <use :xlink:href="'#'+name"></use>
      </svg>
    </el-tooltip>
    <svg width="1em" height="1em" :fill="color?'':'currentColor'" aria-hidden="true" v-else>
      <use :xlink:href="'#'+name"></use>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'Icon',
  props: {
    type: {
      type: String,
      default: 'small'
    },
    content: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    // 自带颜色图标，不能自定义颜色
    color: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data () {
    return {}
  },
  computed: {
  },
  watch: {
    data (newValue, oldValue) {

    }
  },
  methods: {
    handleClick (evt) {
      if (this.disabled) {
        return
      }
      this.$emit('click', evt)
    }
  },
  filters: {}
}
</script>

<style lang="scss">
@import '../../commonStyle/variable';
.custom-icon{
  display: inline-block;
  border-radius: 6px;
  padding: 6px;
  cursor: pointer;
  box-sizing: border-box;
  transition: all 0.2s;
  text-align: center;
  &:hover{
    background-color: rgba(255, 255, 255, 0.1);
  }
  &.big{
    width: 32px;
    height: 32px;
    line-height: 18px;
    >i{
      color: #cccccc;
      font-size: 20px;
    }
    >svg{
      color: #cccccc;
      font-size: 20px;
    }
  }
  &.small{
    width: 24px;
    height: 24px;
    line-height: 10px;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    >i{
      color: #cccccc;
      font-size: 14px;
    }
    >svg{
      color: #cccccc;
      font-size: 20px;
    }
  }
  &.disabled{
    cursor: not-allowed;
    &:hover{
      background-color: unset;
    }
    >i{
      color: rgba(255, 255, 255, 0.4) !important;
    }
    >svg{
      color: rgba(255, 255, 255, 0.4) !important;
    }
  }
}
</style>
